'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const CommandButtonDirective=require('../../../../dist-es6/client/directives/commandButtonDirective/commandButtonDirective');let

CommandCheckboxDirective=class CommandCheckboxDirective extends CommandButtonDirective{
get objectBindings(){
return['onChangeCommand','isChecked','self'];
}

get textBindings(){
return['inProgressText','completionText'];
}

get templateUrl(){
return'/templates/directives/commandCheckboxDirective/commandCheckboxTemplate';
}

get controller(){
return CommandCheckboxDirectiveController;
}

factory(){
let directive=super.factory();
directive.transclude=!0;
return directive;
}};let


CommandCheckboxDirectiveController=class CommandCheckboxDirectiveController{
static get $inject(){
return[];
}

constructor(){
this._id=Guid.create().toString();
}

async onCheckBoxChanged(){
await this.onChangeCommand.execute(this.isChecked);
}

get id(){
return this._id;
}};



module.exports=CommandCheckboxDirective;
//# sourceMappingURL=commandCheckboxDirective.js.map
